import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MultiSelectComponent } from '@engie-group/fluid-design-system-angular';
import { AlertLevel, AlertMessage } from 'src/app/core/Dtos/alert.entity';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { ListItemData } from 'src/app/core/Dtos/list-item-data';
import { MorayEastBidOfferPairDTO } from 'src/app/core/Dtos/moray-east/bid-offer-pair-dto';
import { MorayEastInstructionDTO } from 'src/app/core/Dtos/moray-east/instructions-dto';
import { AdHocInstructionsService } from 'src/app/core/services/ad-hoc-instructions.service';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { GeneralDataService } from 'src/app/core/services/general-data.service';
import { MorayEastService } from 'src/app/core/services/moray-east.service';

@Component({
    selector: 'app-moray-east',
    templateUrl: './moray-east.component.html',
    styleUrl: './moray-east.component.scss',
    standalone: false
})
export class MorayEastComponent {
  public Instruction: MorayEastInstructionDTO = new MorayEastInstructionDTO();
  public BMUList: string[] = [];
  public InstructionType: string = "REGULAR";
  public SettlementPeriods: ListItemData[] = [];
  public bidOfferPair: MorayEastBidOfferPairDTO = new MorayEastBidOfferPairDTO();
  public selectedSettlementPeriods: any;

  @ViewChild(MultiSelectComponent)
  _selectedSettlements: MultiSelectComponent | undefined;

  constructor(
    private _generalDataService: GeneralDataService,
    private _morayEastService: MorayEastService,
    private _router: Router,
    private _alertService: AlertsService,
    private _activatedRoute: ActivatedRoute,
    private _dateFormatHelper: DateFormatHelperService
  ) {
    this.SettlementPeriods = this.GenerateHalfHourBlocks();
    this._generalDataService.GetBMUs(Assets.MorayEast).subscribe(
      resp => {
        this.BMUList = resp;
        let id = _activatedRoute.snapshot.paramMap.get("id");
        if (id !== null)
          this.GetInstruction(parseInt(id));
      }
    );
  }

  GetInstruction(id: number) {
    this._morayEastService.GetInstructionById(id).subscribe(
      resp => {
        debugger;
        this.Instruction = resp;
        this.InstructionType = this.Instruction.isRegular ? "REGULAR" : "OVERWRITE";
        if (!this.Instruction.isRegular) {
          this.Instruction.issuedFrom = "";
          this.Instruction.issuedTo = null;
          this.bidOfferPair = this.Instruction.bidOfferPairs[0];
        }
      }
    )
  }

  public SaveInstruction() {
    if (!this.ValidateInstruction())
      return;

    if (this.InstructionType == "OVERWRITE") {
      const selectedValues = Array.from(this._selectedSettlements?.selectedValues as Set<string>);

      let halfHourBlocks = this.GenerateHalfHourBlocks(),
        startTime, endTime;

      for (let periodId of selectedValues) {
        if (periodId == "0")
        {
          startTime = endTime = "00:00";
        }
        else {
          [startTime, endTime] = halfHourBlocks[Number(periodId)].Description.split(" - ");
        }
        this.Instruction.bidOfferPairs.push({ ...this.bidOfferPair, "periodId": +periodId, "startTime": startTime, "endTime" : endTime})
      }
      this.Instruction.relevantPeriods = selectedValues;
      this.Instruction.isRegular = false;
    }

    this._morayEastService.SaveInstruction(this.Instruction).subscribe(
      resp => this.Cancel()
    );
  }

  private ValidateInstruction(): boolean
  {
    let sErr:string[] = [];
    if ((this.Instruction.units ?? "") == "")
      sErr.push("Affected Unit/s");
    if ((this.Instruction.issuedFrom ?? "") == "")
      sErr.push("Issued From");

    if (this.InstructionType == "OVERWRITE") 
    {
      if (Array.from(this._selectedSettlements?.selectedValues as Set<string>).length == 0)
        sErr.push("No Relevant Settlement Period was selected");
      if ((this.bidOfferPair.minusOne_mainBid?.toString() ?? "") == "")
        sErr.push("-1 Bid Offer Pair Main Bid");
      if ((this.bidOfferPair.minusOne_matchingOffer?.toString() ?? "") == "")
        sErr.push("-1 Bid Offer Pair Matching Offer");
      if ((this.bidOfferPair.plusOne_mainBid?.toString() ?? "") == "")
        sErr.push("+1 Bid Offer Pair Main Bid");
      if ((this.bidOfferPair.plusOne_matchingOffer?.toString() ?? "") == "")
        sErr.push("+1 Bid Offer Pair Matching Offer");
    }
    else
    {
      if((this.Instruction.strikePrice ?? "").toString() == "")
        sErr.push("Strike Price");
      if((this.Instruction.fixedCosts ?? "").toString() == "")
        sErr.push("Fixed Costs");
      if((this.Instruction.negativePriceTrigger ?? "").toString() == "")
        sErr.push("Negative Price Trigger");
    }

    if (sErr.length != 0)
    {
      this._alertService.ShowAlert(new AlertMessage(AlertLevel.Error, `The following fields are missing: \n\r ${sErr.join(", ")} `));
      return false;
    }
    return true;
  }

  public Cancel() {
    this._router.navigate(['moweo']);
  }

  private GenerateHalfHourBlocks(): ListItemData[] {
    const items: ListItemData[] = [];
    const hours = 24;
    const blocksPerHour = 2;
    items.push(new ListItemData(0, "All"));
    for (let i = 0; i < hours * blocksPerHour; i++) {
      const startHour = Math.floor(i / blocksPerHour);
      const startMinute = (i % blocksPerHour) * 30;
      const endHour = startHour + Math.floor((startMinute + 30) / 60);
      const endMinute = (startMinute + 30) % 60;

      const startTime = `${String(startHour).padStart(2, '0')}:${String(startMinute).padStart(2, '0')}`;
      const endTime = `${String(endHour % 24).padStart(2, '0')}:${String(endMinute).padStart(2, '0')}`;

      const description = `${startTime} - ${endTime}`;
      items.push(new ListItemData(i + 1, description));
    }

    return items;
  }
}
